// extracted by mini-css-extract-plugin
export var formContainer = "_g0-0";
export var message = "_g0-1";